module.exports = __webpack_public_path__ + "img/Output84.ba847cec.png";